import React from 'react'
import { AddKeyValue } from '../../AddKeyValue'

export const A8Config = () => {
  return (
    <div>
      <AddKeyValue field="a8config" />
    </div>
  )
}
